import React, { useState, useEffect } from 'react';
import Style from '../assets/css/earth.module.css';

const Earth = () => {
    const [longitude, setLongitude] = useState(-99.133456);
    const [latitude, setLatitude] = useState(19.432726);
    const [date, setDate] = useState('2024-11-08T21:00:00Z');

    useEffect(() => {
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(
                (position) => {
                    setLatitude(position.coords.latitude);
                    setLongitude(position.coords.longitude);
                },
                (error) => {
                    alert('No se pudo obtener la ubicación: ' + error.message);
                }
            );
        } else {
            alert('La geolocalización no es soportada por tu navegador.');
        }
    }, []); 

    return (
        <>
            <div className={Style.stellariumContainer}>
                <div className={Style.stellariumTitleContainer}>
                    <h1 className={Style.stellariumTitle}>Stellarium</h1>
                </div>
                <iframe
                    src={`https://stellarium-web.org/#sky-map?lat=${latitude}&lng=${longitude}&date=${date}`}
                    title="Stellarium Web"
                    className={Style.stellarium}
                ></iframe>
            </div>
        </>
    );
};

export default Earth;
